import axios from "@/lib/axios";

const getPromoCare = () => {
  return axios.get("/facility/orders/promo_care");
}

export default getPromoCare;